(function () {
  var root = document.querySelector(".hl-intake");
  if (!root) return;

  var screens = [].slice.call(root.querySelectorAll(".screen"));
  var path = [].slice.call(root.querySelectorAll("#hlIntakePath li"));
  var form = root.querySelector("#hlIntakeForm");
  var statusEl = root.querySelector("#hlIntakeStatus");
  var i = 0;
  var signedAtEl = form.querySelector("#hlSignedAt");
  if (signedAtEl && !signedAtEl.value) {
    signedAtEl.value = new Date().toLocaleDateString();
  }

  function show(n) {
    i = n;
    screens.forEach(function (s, idx) {
      s.classList.toggle("is-on", idx === n);
    });
    path.forEach(function (p, idx) {
      p.className = idx < n ? "is-done" : idx === n ? "is-now" : "";
    });
    window.scrollTo(0, 0);
  }

  function val(name) {
    var el = form.querySelector('[name="' + name + '"]');
    if (!el) return "";
    if (el.type === "checkbox") return el.checked ? "yes" : "";
    return (el.value || "").trim();
  }

  function radio(name) {
    var el = form.querySelector('[name="' + name + '"]:checked');
    return el ? el.value : "";
  }

  function screenInvalid(screen) {
    var fields = screen.querySelectorAll("input, textarea, select");
    for (var n = 0; n < fields.length; n++) {
      var el = fields[n];
      if (el.disabled) continue;
      if (!el.checkValidity()) {
        el.reportValidity();
        return true;
      }
    }
    return false;
  }

  root.querySelectorAll("[data-next]").forEach(function (b) {
    b.addEventListener("click", function () {
      var screen = screens[i];
      if (screen && screenInvalid(screen)) return;
      if (i === 6) {
        submitIntake();
        return;
      }
      show(Math.min(i + 1, screens.length - 1));
    });
  });

  root.querySelectorAll("[data-back]").forEach(function (b) {
    b.addEventListener("click", function () {
      show(Math.max(i - 1, 0));
    });
  });

  root.querySelectorAll(".yn").forEach(function (block) {
    function setOpen(yes) {
      block.classList.toggle("is-yes", yes);
      var box = block.querySelector(".reveal");
      var ta = block.querySelector("textarea");
      if (box) box.hidden = !yes;
      if (!ta) return;
      ta.disabled = !yes;
      if (!yes) ta.value = "";
    }
    block.addEventListener("change", function (e) {
      if (e.target.type !== "radio") return;
      var yes = e.target.value === "Yes";
      setOpen(yes);
      if (yes) {
        var ta = block.querySelector("textarea");
        if (ta) ta.focus();
      }
    });
    var checked = block.querySelector('input[type="radio"]:checked');
    setOpen(checked && checked.value === "Yes");
  });

  function payload() {
    return {
      firstName: val("firstName"),
      lastName: val("lastName"),
      preferredName: val("preferredName"),
      email: val("email"),
      phone: val("phone"),
      dateOfBirth: val("dateOfBirth"),
      referralSource: val("referralSource"),
      emergencyContact: val("emergencyContact"),
      emergencyPhone: val("emergencyPhone"),
      reasonForTherapy: val("reasonForTherapy"),
      priorTherapy: radio("priorTherapy"),
      priorTherapyDetail: val("priorTherapyDetail"),
      medications: radio("medications"),
      medicationsDetail: val("medicationsDetail"),
      medicalConditions: radio("medicalConditions"),
      medicalConditionsDetail: val("medicalConditionsDetail"),
      mhDiagnosis: radio("mhDiagnosis"),
      mhDiagnosisDetail: val("mhDiagnosisDetail"),
      selfHarm: radio("selfHarm"),
      selfHarmDetail: val("selfHarmDetail"),
      lifeEventsTraumas: val("lifeEventsTraumas"),
      primaryGoals: val("primaryGoals"),
      consentAck: form.querySelector('[name="consentAck"]').checked,
      marketingOptIn: form.querySelector('[name="marketingOptIn"]').checked,
      signature: val("signature"),
      signedAt: val("signedAt") || new Date().toLocaleDateString(),
      company: val("company"),
      _submittedAt: new Date().toISOString(),
    };
  }

  function submitIntake() {
    if (screenInvalid(screens[i])) return;
    if (signedAtEl) signedAtEl.value = new Date().toLocaleDateString();
    var btn = root.querySelector('[data-next][data-submit]');
    if (btn) btn.disabled = true;
    if (statusEl) {
      statusEl.className = "status";
      statusEl.textContent = "";
    }
    var url = form.getAttribute("data-hl-intake-url");
    fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload()),
    })
      .then(function (r) {
        return r.json().then(function (j) {
          return { ok: r.ok, j: j };
        });
      })
      .then(function (res) {
        if (!res.ok || !res.j.ok) {
          throw new Error(
            (res.j && res.j.message) ||
              "We could not save your intake. Please call or text 754-273-5510."
          );
        }
        show(7);
      })
      .catch(function (err) {
        if (statusEl) {
          statusEl.className = "status is-err";
          statusEl.textContent =
            err.message ||
            "We could not save your intake. Please call or text 754-273-5510.";
        }
        if (btn) btn.disabled = false;
      });
  }
})();
